import { map, some, sortBy } from 'lodash';

// import * as Raven from 'raven-js';
import * as Api from './Api';

export interface GoogleTools {
  AutoComplete: google.maps.places.AutocompleteService;
  GeoCoder: google.maps.Geocoder;
}

export interface Config {
  DeviceId: string;
  IncludePhysicalRestaurantIds: string;
  showRestaurantList: boolean;
}

export const LatLng = (Geo: Api.Geo): google.maps.LatLng =>
  new google.maps.LatLng(Geo.Latitude, Geo.Longitude);

export const ToGeo = (p: google.maps.LatLng): Api.Geo => ({
  Latitude: p.lat(),
  Longitude: p.lng(),
});

export function ClosestDeliveryLocation(
  point: google.maps.LatLng,
  max: number,
  locations: Async<Api.DeliveryLocation[]>,
): Api.DeliveryLocation | null {
  interface LocationAndDistance {
    DeliveryLocation: Api.DeliveryLocation;
    Distance: number;
  }

  const distance = (dl: Api.DeliveryLocation): LocationAndDistance => {
    const d = google.maps.geometry.spherical.computeDistanceBetween(
      point,
      LatLng(dl.Coordinates),
    );
    return {
      DeliveryLocation: dl,
      Distance: d,
    };
  };

  if (locations.status !== 'success') {
    return null;
  }

  const distances: LocationAndDistance[] = map(locations.data, distance);
  const sorted = sortBy(distances, 'Distance');

  if (!some(sorted)) {
    return null;
  }

  const closest = sorted[0];
  if (closest.Distance > max) {
    return null;
  }

  return closest.DeliveryLocation;
}

export const DefaultPaymentAccount = function (
  asyncAccounts: Async<Api.PaymentAccount[]>,
): Api.PaymentAccount | null {
  const { status } = asyncAccounts;
  if (status !== 'success') {
    return null;
  }

  const { data: accounts } = asyncAccounts;
  if (accounts.length < 1) {
    return null;
  }

  let defaultAccount = accounts.filter((p) => p.IsDefaultPaymentMethod)[0];

  if (!defaultAccount) {
    // Raven.captureMessage(
    //   'user has no default payment account - using first account',
    // );
    defaultAccount = accounts[0];
  }

  return defaultAccount;
};

export const OutsideDeliveryZone = (
  restaurant: Api.CollectionRestaurantDetail | Api.DeliveryRestaurantDetail,
) =>
  restaurant.DeliveryType === Api.DeliveryType.Delivery &&
  restaurant.UserOutsideDeliveryZone;

interface None {
  status: 'none';
  error?: string | Error;
}

interface Pending {
  status: 'pending';
}

interface Loaded<T> {
  status: 'success';
  data: T;
}

export type Async<T> = Pending | None | Loaded<T>;

export const flatMap = function <T>(collection: Array<Async<T>>): T[] {
  const result: T[] = [];
  collection.forEach((c) => {
    if (c.status === 'success') {
      result.push(c.data);
    }
  });
  return result;
};

// From react
export type ValidationState = 'error' | 'success' | 'warning' | undefined;

export const Sorted = function <T extends Api.Ordered>(items: T[]): T[] {
  return sortBy(items, (i) => i.DisplayOrder);
};
